var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-results"},[_c('div',{staticClass:"loading-results-inner"},[_c('div',{staticClass:"loading-results-logo"}),_c('p',[_vm._v(_vm._s(_vm.t('Creating your personalized nutrition plan...')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }